
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Line, Bar, mixins } from 'vue-chartjs';
@Component({})
export default class LineChartComponent extends Mixins(Line, Bar, mixins.reactiveProp) {
    @Prop() public chartData: Chart.ChartData;
    @Prop() public chartOptions: Chart.ChartOptions;
    public mounted() {
        this.onDataChanged();
    }
    @Watch('chartData')
    onDataChanged() {
        this.renderChart(this.chartData, this.chartOptions);
    }
}
